module.exports = "<a href=\"#\" ng-click=\"$ctrl.openModal()\" class=\"{{$ctrl.klass}}\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i>{{$ctrl.text}}</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/eform-link/eform-link.component.html
// module id = 978
// module chunks = 0